export default "__VITE_ASSET__CWkJfkRm__"